import React, { Component } from 'react';
import axios from 'axios';
import { config } from '../../Constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../Asset/Css/Site.css';
import Select from 'react-select';
import global from '../global';
import 'react-notifications-component/dist/theme.css'
import { Card, Row, Col, InputGroup, FormControl, Button } from 'react-bootstrap';
import '../../Asset/Css/util.css';
import '../../Asset/Css/main.css';
import { store } from 'react-notifications-component';
import ReactNotification from 'react-notifications-component';
import mainBG from '../../Asset/Images/easy-dividend-bg.png';
import goBack from '../../Asset/Images/previous-icon.png';
import queryString from 'query-string';
import DebenturesHubLogo from '../../Asset/Images/Debentures-Hub-logo.svg';
import NexdmsmImg from '../../Asset/Images/nexdigm-logo-sm.png';
import {
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import { getYearOptions } from '../../utils/yearUtil';



const yearoptions = getYearOptions();
export class FillManually extends Component {
    constructor(props) {
        super(props);
        this.state = {
            TypeOfBeneficiary: [],
            BeneficiaryName: '',
            AssignmentCode: '',
            PAN: '',
            DPID: '',
            flag: '',
            loading: false,
            IsOnlineOffline: 0,
            modal: false,
            selectedYear: null,
            uploadModal: false,
            uploadForm121File: null
        };

        this.initialState = this.state;
        global.IpAddress = localStorage.getItem('IPaddress');
        localStorage.clear(); //for localStorage
        sessionStorage.clear(); //for sessionStorage
        this.state.loading = false;

        const parsed = queryString.parse(window.location.search);
        this.state.AssignmentCode = parsed['AC'] == undefined ? 0 : window.atob(parsed['AC']);
        this.state.PAN = parsed['PN'] == undefined ? 0 : window.atob(parsed['PN']);
        this.state.DPID = parsed['DP'] == undefined ? 0 : window.atob(parsed['DP']);
        this.state.BeneficiaryName = parsed['BN'] == undefined ? "" : window.atob(parsed['BN']);
    }

    showNoti(title, message, type) {
        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });
    };

    // Method to check if current date is on or after April 1st, 2026
    isAfterApril2026 = () => {
        const currentDate = new Date();
        const april2026 = new Date(2026, 3, 1); // Month is 0-indexed, so 3 = April
        return currentDate >= april2026;
    };


    // Direct redirect to Form121 without modal
    redirectToForm121 = () => {
        this.setState({ loading: true });
        this.state.flag = 'U';
        this.state.IsOnlineOffline = 1;

        const demoForm15GH = {
            ...this.state,
            selectedYear: '2026-2027' // Default to 2026-2027 for Form121
        };

        axios.post(global.OfflineResident.SubmitOfflineForm15GHAPI, demoForm15GH,
            {
                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` }
            })
            .then(response => {
                if (response.data.status) {
                    // Direct redirect to Form121
                    const redirectUrl = config.url.Web_URL + "/Resident/Form121?AC=" + window.btoa(this.state.AssignmentCode) + '&DP=' + window.btoa(this.state.DPID) + '&PN=' + window.btoa(0) + '&OF=' + window.btoa(this.state.IsOnlineOffline);
                    window.location.href = redirectUrl;
                    this.setState({ loading: false });
                }
                else {
                    this.setState({ loading: false });
                    this.showNoti("Error", response.data.message || "An error occurred", "danger");
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ loading: false });
                this.showNoti("Error", "An error occurred while processing your request", "danger");
            });
    };



    handleClick = (e) => {
        e.preventDefault();
        // Check if current date is on or after April 1st, 2026
        //if (this.isAfterApril2026()) {
        //    // Directly redirect to Form121 without opening modal
        //    this.redirectToForm121();
        //} else {
        // Open modal for year selection (existing behavior)
        this.setState({ modal: true });

    };

    handleClickOld = (e) => {
        e.preventDefault();
        this.state.flag = 'U';
        this.state.IsOnlineOffline = 1;

        const demoForm15GH = this.state;

        axios.post(global.OfflineResident.SubmitOfflineForm15GHAPI, demoForm15GH,
            {
                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` }
            })
            .then(response => {
                if (response.data.status) {
                    window.location.href = config.url.Web_URL + "/Resident/Form15GH?AC=" + window.btoa(this.state.AssignmentCode) + '&DP=' + window.btoa(this.state.DPID) + '&PN=' + window.btoa(0) + '&OF=' + window.btoa(this.state.IsOnlineOffline);
                    this.setState({ loading: false });
                }
                else {
                    this.setState({ loading: false });
                }
            })
            .catch(error => {
                console.log(error);
            });
    };

    handleManually = (e) => {
        e.preventDefault();
        this.setState({ uploadForm121File: false });
        this.setState({ uploadModal: true });

    };

    handleProceedClick = (e) => {
        e.preventDefault();

        if (!this.state.selectedYear) {
            this.showNoti("Validation", "Please select a year before proceeding.", "warning");
            return;
        }

        this.setState({ loading: true, modal: false });
        this.state.flag = 'U';
        this.state.IsOnlineOffline = 1;

        const demoForm15GH = {
            ...this.state,
            selectedYear: this.state.selectedYear.value
        };

        axios.post(global.OfflineResident.SubmitOfflineForm15GHAPI, demoForm15GH,
            {
                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` }
            })
            .then(response => {
                if (response.data.status) {
                    // Redirect based on selected year
                    const selectedYear = this.state.selectedYear;
                    let redirectUrl;
                    if (selectedYear === '2025-2026') {
                        // Redirect to Form15GH
                        redirectUrl = config.url.Web_URL + "/Resident/Form15GH?AC=" + window.btoa(this.state.AssignmentCode) + '&DP=' + window.btoa(this.state.DPID) + '&PN=' + window.btoa(0) + '&OF=' + window.btoa(this.state.IsOnlineOffline);
                    } else {
                        // Redirect to Form121
                        redirectUrl = config.url.Web_URL + "/Resident/Form121?AC=" + window.btoa(this.state.AssignmentCode) + '&DP=' + window.btoa(this.state.DPID) + '&PN=' + window.btoa(0) + '&OF=' + window.btoa(this.state.IsOnlineOffline) + '&FY=' + window.btoa(this.state.selectedYear);
                    }

                    window.location.href = redirectUrl;
                    this.setState({ loading: false });
                }
                else {
                    this.setState({ loading: false });
                    this.showNoti("Error", response.data.message || "An error occurred", "danger");
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ loading: false });
                this.showNoti("Error", "An error occurred while processing your request", "danger");
            });
    };

    handleCancel = (e) => {
        e.preventDefault();
        window.location.href = config.url.Web_URL;
    }

    handleYear = (selectedOption) => {
        this.setState({ selectedYear: selectedOption.value });
    };

    modalClose = (e) => {
        e.preventDefault();
        this.setState({ modal: false, selectedYear: null });
    };

    uploadModalClose = (e) => {
        if (e) {
            e.preventDefault();
        }
        this.setState({ uploadModal: false });
    };

    handleUploadClick = (e) => {
        e.preventDefault();

        if (this.uploadInProgress || this.state.loading) {
            return;
        }

        if (!this.state.uploadForm121File) {
            this.showNoti("Validation", "Please select a PDF before uploading.", "warning");
            return;
        }

        this.uploadInProgress = true;
        this.setState({ loading: true });
        this.state.flag = 'U';
        this.state.IsOnlineOffline = 1;

        const formData = new FormData();
        formData.append("uploadForm121File", this.state.uploadForm121File);
        formData.append("flag", this.state.flag);
        formData.append("IsOnlineOffline", this.state.IsOnlineOffline);
        formData.append("PAN", this.state.PAN);
        formData.append("DPID", this.state.DPID);
        formData.append("assignmentCode", this.state.AssignmentCode);
        formData.append("beneficiaryName", this.state.BeneficiaryName);

        axios.post(global.OfflineResident.SubmitOfflineManuallyForm15GHAPI, formData,
            {
                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` }
            })
            .then(response => {
                if (response.data.status) {
                    return axios.post(global.OfflineResident.SendManuallyDataEmailAPI, formData)
                        .then(json => {
                            if (json.data.status) {
                                this.showNoti("Notification", "Manually submitted successfully; check on your entered email.", "success");
                                this.setState({ showTiming: 'block', showReOTP: 'none', time: {}, seconds: 300 });
                                this.uploadModalClose();
                                setTimeout(() => {
                                    window.location.href = config.url.Web_URL + "/Resident";
                                }, 2000);
                            }
                            else {
                                this.setState({
                                    showValidateOTP: 'none',
                                    showRegisterDetails: 'block'
                                });

                                this.showNoti("Notification", json.data.message, "danger");
                            }
                        });
                }
                else {
                    this.showNoti("Error", response.data.message || "An error occurred", "danger");
                }
            })
            .catch(error => {
                console.log(error);
                this.showNoti("Error", "An error occurred while processing your request", "danger");
            })
            .finally(() => {
                this.uploadInProgress = false;
                this.setState({ loading: false });
            });
    }

    handelFileChange = (event) => {
        let file = event.target.files[0];

        if (!file) return;

        const mimeType = file.type;
        const maxSize = 10 * 1024 * 1024; // 10 MB in size

        if (mimeType !== "application/pdf") {
            this.showNoti("Notification", global.Message.PDFFormatRequiredMessage, "danger");
            return;
        }
        else if (file.size > maxSize) {
            this.showNoti("Notification", global.Message.FileSize10MBMessage, "danger");
            return;
        }
        else {
            this.setState({ uploadForm121File: file });
        }
    };


    render() {

        return (
            <div>
                <ReactNotification />
                <div class="limiter">
                    <div class="container-login100" style={{ backgroundImage: 'url("' + mainBG + '")' }}>
                        <div className="content-page">
                            <div className="card m-t-20" >
                                <img src={DebenturesHubLogo} alt="Logo" className="logo-img" />
                                <div className="card-body border-none">
                                    <h4 className="header-title text-center" style={{ texttransform: 'math-auto;' }}>Kindly submit your form by selecting any one of below. </h4>
                                    <Row className="w-100" style={{ margin: 'auto' }}>
                                        <Col md={6}>
                                            <a href="#" onClick={this.handleClick} className="text-white">
                                                {/*config.url.Web_URL + "/Resident/Form15GH?AC=" + window.btoa(this.state.AssignmentCode) + '&PN=' + window.btoa(this.state.PAN) + '&DP=' + window.btoa(this.state.DPID)*/}
                                                <div className="icon_box">
                                                    <h3>Fill Form</h3>
                                                </div>
                                            </a>
                                        </Col>
                                        <Col md={6}>
                                            <a href="#" onClick={this.handleManually} className="text-black">
                                                <div className="icon_box">
                                                    {/*<FontAwesomeIcon icon="user-alt" size="5x" color="#c21ee2"   />*/}
                                                    <h3>Manually Submit Form</h3>
                                                </div>
                                            </a>
                                        </Col>
                                        <div className="txt1 text-center p-t-20" style={{ textAlign: "center" }}>
                                            <span style={{ verticalAlign: "middle" }}>Powered by </span>
                                            <img src={NexdmsmImg} style={{ verticalAlign: "middle" }} />
                                        </div>
                                    </Row>
                                </div>
                            </div>
                            <div className="clear"></div>
                            <img src={goBack} class="go_back" onClick={this.handleCancel} alt="Go to previous page" title="Go to previous page" />
                        </div>
                    </div>
                    <Modal isOpen={this.state.modal} toggle={e => this.modalClose(e)} size="md">
                        <ModalHeader toggle={this.handleCloseModal}>Select Tax Year</ModalHeader>
                        <ModalBody>
                            <Row>
                                <Col md={6} className="m-t-10 cursor-not-allowed-disable-dropdown">
                                    <label htmlFor="status" className="required-field">Select Tax Year</label>
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="Select Year"
                                        isDisabled={false}
                                        options={yearoptions}
                                        value={yearoptions.find(obj => obj.label === this.state.selectedYear)}
                                        onChange={this.handleYear.bind(this)}
                                    />

                                </Col>
                            </Row>

                        </ModalBody>
                        <ModalFooter>
                            <button className="btn btn-success" type="button" onClick={this.handleProceedClick}>Proceed</button>
                            <button className="btn btn-dark m-l-10" type="button" onClick={e => this.modalClose(e)}>Cancel</button>
                        </ModalFooter>
                    </Modal>

                    <Modal isOpen={this.state.uploadModal} toggle={e => this.modalClose(e)} size="md">
                        <ModalHeader>Upload Form 121</ModalHeader>
                        <ModalBody>
                            <Row>
                                <Col md={12}>
                                    <input type="file" name="files" multiple onChange={this.handelFileChange} />
                                </Col>
                            </Row>

                        </ModalBody>
                        <ModalFooter>
                            <button disabled={this.state.loading} className="btn btn-success" type="button" onClick={this.handleUploadClick}>Upload</button>
                            <button className="btn btn-dark m-l-10" type="button" onClick={e => this.uploadModalClose(e)}>Cancel</button>
                        </ModalFooter>
                    </Modal>
                </div>



            </div>
        )
    }
}